/* eslint-disable camelcase */

import { UserFeedbackDangerousState } from '../../enum'

export class UserFeedback {
  constructor ({ dangerous_state = UserFeedbackDangerousState.UNKNOWN, feedback = 0 } = {}) {
    this.dangerousState = dangerous_state
    this.feedback = feedback
  }
}
